export const getIP = async () => {
  // DO NOT CHANGE THIS BASE URL OR USE ENVIRONMENT VARIABLE
  // ELSE THE IP ADDRESS & COUNTRY CODE CHECK WILL FAIL
  const response = await fetch("https://sb-apis.ibunchng.com/marketplace/v1/public/identity");
  const data = await response.json();
  return data.ip_address;
};
